export default "__VITE_ASSET__DDps$W8r__"